import React from 'react';
import { View, Text } from 'react-native';
import { useThemeColors } from '@/lib/useThemeColors';
import { MiniBarChart } from './MiniBarChart';

interface UserEngagementChartProps {
  data: { date: string; count: number }[];
  title?: string;
}

export function UserEngagementChart({ data, title = 'Activity (14 days)' }: UserEngagementChartProps) {
  const colors = useThemeColors();

  const chartData = data.map((d) => ({ label: d.date, value: d.count }));

  return (
    <View>
      <Text style={{ color: colors.text.secondary }} className="text-xs font-semibold mb-3">
        {title}
      </Text>
      <MiniBarChart data={chartData} height={80} showLabels={data.length <= 14} />
    </View>
  );
}
